<template>
  <div>
    {{ displayValue }}
  </div>
</template>

<script>
export default {
  name: 'AppVideoCompletion',
  props: {
    value: {
      type: [Number, Boolean],
      default: null,
    },
    localString: {
      type: Boolean,
      default: false,
    },
    fallbackText: {
      type: String,
      default: '',
    },
  },
  computed: {
    displayValue() {
      if (typeof this.value !== 'number') {
        return this.fallbackText
      }
      if (this.value === 0) return '-'
      return this.localString ? this.value.toLocaleString() : this.value
    },
  },
}
</script>

<style scoped></style>
